import React from 'react';
import AdminTable from 'layouts/AdminTable';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import DataGrid from 'components/DataGrid/DataGrid';
import { isGranted } from 'helpers/helpers';
import {
  ROLE_CREATE_PACKAGE_LINE_FILTER,
  ROLE_REMOVE_PACKAGE_LINE_FILTER,
  ROLE_SHOW_PACKAGE_LINE_FILTER,
} from 'helpers/roles';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import makeStyles from '@material-ui/styles/makeStyles';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';

import columnConfig from './columnConfig';

const useStyles = makeStyles(() => ({
  adminTableTitleParent: { display: 'flex', alignItems: 'center' },
}));

const List = ({ classes: propClasses, t, history }) => {
  const newSize = () => history.push(`${window.location.pathname}/add`);

  const classes = useStyles();

  return (
    <AdminTable
      title={
        <span className={classes.adminTableTitleParent}>
          {t('list.dietsLineFilters')}
          <span>
            <InfoIconTooltip title={t('list.dietsLineFilters.tooltip')} />
          </span>
        </span>
      }
    >
      {isGranted(ROLE_CREATE_PACKAGE_LINE_FILTER) && (
        <FormControlButtons
          classes={propClasses}
          handleSubmit={newSize}
          submitText={`${t('form.addNewLine')} +`}
        />
      )}
      <DataGrid
        actions={true}
        export={true}
        editPath={`${window.location.pathname}/edit`}
        remove={isGranted(ROLE_REMOVE_PACKAGE_LINE_FILTER)}
        paginationTop={true}
        paginationBottom={false}
        url="package-line-filters"
        reportName="packagelinefilter"
        columns={columnConfig(t)}
        role={ROLE_SHOW_PACKAGE_LINE_FILTER}
      />
    </AdminTable>
  );
};

const enhance = compose(withTranslation(), withStyles(buttonsStyle));

export default enhance(List);
